import { useState } from "react"
import { useModalWindow } from "react-modal-global"
import { useInterval } from "react-use"

import { EventDto } from "@/entities/app/menu/menu.dto"
import PopupLayout from "@/services/Modal/layouts/PopupLayout/PopupLayout"
import Button from "@/shared/components/intrinsic/Button/Button"
import Buttons from "@/shared/layouts/Buttons/Buttons"


interface PopupConfirmEventDeleteProps {
  event: EventDto
  onSubmit?(): void
}

function PopupConfirmEventDelete(props: PopupConfirmEventDeleteProps) {
  const modal = useModalWindow()
  const [timer, setTimer] = useState(3)

  useInterval(() => setTimer(timer => timer - 1), 1000)

  function onConfirm() {
    modal.close()
    props.onSubmit?.()
  }

  return (
    <PopupLayout title="Delete Event">
      <p>Are you sure you want to delete the event "{props.event.name}"?</p>
      <Buttons>
        <Button color="gray" disabled={timer > 0} onClick={onConfirm}>
          {timer > 0 ? ("Wait " + timer) : "Delete"}
        </Button>
        <Button color="dark" onClick={modal.close}>Cancel</Button>
      </Buttons>
    </PopupLayout>
  )
}

export default PopupConfirmEventDelete
